import CuentasList from './List.jsx';

export default function CuentasPage() {
  return <CuentasList />;
}
